/* eslint-disable */
import axios from "axios";
import {
    isTaikangSalesmanMode,
    isTaikangSalesmanSession,
    getSanGaoSalesmanSessionOrgId,
    clearSanGaoSalesmanSession,
} from "@/utils/sanGaoSalesmanMode";

function redirectToSalesmanLogin() {
    // 先读取机构与版本再清登录信息，HTTP 401 和业务 401 使用同一个回退入口。
    const currentQuery = new URLSearchParams(window.location.search);
    const taikangMode = currentQuery.has("taikang")
        ? isTaikangSalesmanMode({ taikang: currentQuery.get("taikang") })
        : isTaikangSalesmanSession();
    const orgId = currentQuery.get("orgId") || getSanGaoSalesmanSessionOrgId();
    clearSanGaoSalesmanSession();
    const loginQuery = new URLSearchParams({ type: "login" });
    if (orgId) loginQuery.set("orgId", orgId);
    if (taikangMode) loginQuery.set("taikang", "1");
    const loginUrl = `/sanGao/salesman/login?${loginQuery.toString()}`;
    if (window.location.pathname + window.location.search !== loginUrl) {
        window.location.replace(loginUrl);
    }
}

class RequestManager {
    constructor() {
        this.axiosInstance = axios.create({
            //baseURL: 'http://localhost:8091',
            baseURL: "https://yisheng.healthmore.net/api",
            timeout: 30 * 1000,
        });
        this._configInterceptors();
        this.defaultErrorHandler = function () {};
    }

    static _instance = null;

    static getInstance() {
        if (null == RequestManager._instance) {
            RequestManager._instance = new RequestManager();
        }
        return RequestManager._instance;
    }

    _configInterceptors() {
        this.axiosInstance.interceptors.request.use(
            (config) => {
                config.headers["Content-Type"] = "application/json; charset=UTF-8";
                const token = localStorage.getItem("san_gao_salesman_token");
                if (token) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                }
                return config;
            },
            (error) => Promise.reject(error)
        );

        this.axiosInstance.interceptors.response.use(
            (response) => {
                const res = response.data;
                if (res && (res.code === 401 || res.code === "401")) {
                    redirectToSalesmanLogin();
                }
                return response;
            },
            (error) => {
                if (error.response && error.response.status === 401) redirectToSalesmanLogin();
                return Promise.reject(error);
            }
        );
    }

    request(options) {
        options = Object.assign({}, options);
        const params = options.params || {};
        const errorHandler = params.errorHandler || this.defaultErrorHandler;
        delete params.errorHandler;
        return this.axiosInstance(options)
            .then((res) => res.data)
            .catch((error) => {
                errorHandler(error);
                return Promise.reject(error);
            });
    }

    setDefaultErrorHandler(defaultErrorHandler) {
        this.defaultErrorHandler = defaultErrorHandler;
    }
}

export default new RequestManager();
